import type {SvgIconData} from '@repo/shared-web/components/core/svg_icon';

export const chevronDownIcon: SvgIconData = {
  viewBox: '6 8.5 12 7.5',
  element: <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />,
};
